// import { apiSlice } from "../../app/api/apiSlice";

import { apiSlice } from "../../api/apiSlice";

export const configApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConfig: builder.query({
      query: () => "/api/config",
    }),
    getPrivacyPolicy: builder.query({
      query: () => "/api/config/privacy",
    }),
    getTermsConditions: builder.query({
      query: () => "/api/config/terms",
    }),
    updateConfig: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/config/${id}`,
        method: "PATCH",
        body: { ...data },
      }),
    }),

    updateAdvertise: builder.mutation({
      query: ({ id, ...data }) => {
        return {
          url: `/api/config/${id}`,
          method: "PATCH",
          body: { ...data },
        };
      },
    }),
  }),
});

export const {
  useGetConfigQuery,
  useUpdateConfigMutation,
  useGetTermsConditionsQuery,
  useGetPrivacyPolicyQuery,
  useUpdateAdvertiseMutation,
} = configApiSlice;
